import { render } from "./HeaderTop.vue?vue&type=template&id=198b398e&scoped=true"
import script from "./HeaderTop.vue?vue&type=script&lang=js"
export * from "./HeaderTop.vue?vue&type=script&lang=js"

import "./HeaderTop.vue?vue&type=style&index=0&id=198b398e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\feegor\\PycharmProjects\\menlor\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-198b398e"]])

export default __exports__